import React, { Component } from 'react';
import * as firebase from "firebase";
import logo from './logo.svg';
import './App.css';

// Initialize Firebase
var config = {
  apiKey: "AIzaSyA9awFuEMdhyU8jUoSeuK_JiggdYXeMJQ0",
  authDomain: "screendroid-8980d.firebaseapp.com",
  databaseURL: "https://screendroid-8980d.firebaseio.com",
  projectId: "screendroid-8980d",
  storageBucket: "screendroid-8980d.appspot.com",
  messagingSenderId: "559309534087"
};

firebase.initializeApp(config);

class App extends Component {
  render() {
    return (
      <div className="App">
        <div className="Screen">
          <div className="Screen-content">
            <h2>screendroid</h2>
          </div>
        </div>
        <p className="App-intro">
        </p>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js